import { select, call, put, takeLatest } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const HrUserToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const generatePassword = () => {
  const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const digits = '0123456789';
  const specials = '!@#$%^&*';
  const all = letters + digits + specials;

  let password = '';
  password += letters[Math.floor(Math.random() * letters.length)];
  password += digits[Math.floor(Math.random() * digits.length)];
  password += specials[Math.floor(Math.random() * specials.length)];

  for (let i = 3; i < 9; i++) {
    password += all[Math.floor(Math.random() * all.length)];
  }

  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
};

const createHrUser = function* ({ payload }) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);
  const { name, email } = payload;
  const password = generatePassword();

  try {
    yield put($ui.setTrue(UI.Datasets.IsCreatingHrUser)());

    yield call(api.createHrUser, { email, name, password }, { token, publisherId });

    yield put($ui.setFalse(UI.Datasets.CreateHrUserDialogVisible)());

    yield call([navigator.clipboard, navigator.clipboard.writeText], password);

    HrUserToaster.show({
      icon: 'tick',
      intent: Intent.SUCCESS,
      message: 'HR user created successfully. Password copied to clipboard.',
    });
  } catch (error) {
    HrUserToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while creating the HR user',
    });
  } finally {
    yield put($ui.setFalse(UI.Datasets.IsCreatingHrUser)());
  }
};

export const createHrUserSaga = function* () {
  yield takeLatest(actions.createHrUser, createHrUser);
};
